const DEFAULT_BASE_URLS = {
  production: 'https://ivqsyb7jenmdyj3pff4bdyvtmu0satvx.lambda-url.us-east-1.on.aws/',
  development: 'https://kzbcbcuhvk6j7pson75lvwyjby0fopec.lambda-url.us-east-1.on.aws/'
};

const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const fallbackBaseUrl = process.env.NODE_ENV === 'production'
  ? DEFAULT_BASE_URLS.production
  : DEFAULT_BASE_URLS.development;

const BASE_URL = configuredBaseUrl || fallbackBaseUrl;

export default BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;